import { AbstractDTO } from "@signature-it/ngx-generic/models";
import {ProductFieldDTO} from './product-field';

export class GroupUserLinksFields extends AbstractDTO {
	id: number;
    taxonomy: string;
    entityVar: string;
	fields: Array<ProductFieldDTO>;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = attributes['id'] || -1;
        this.taxonomy = attributes['taxonomy'] || '';
        this.entityVar = attributes['entityVar'] || '';
        this.fields = ProductFieldDTO.createFromArray(attributes['fields']);
    }
}
